module.exports = __webpack_public_path__ + "static/media/bg2.84378183.jpg";